import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ACLService } from "@delon/acl";
import { zip } from "rxjs";
import { catchError, finalize } from "rxjs";
import { AppService } from "@root/app.service";
import { StoreService } from "./shared/service/store.service";

@Injectable({
  providedIn: "root",
})
export class StartupService {
  constructor(
    private http: HttpClient,
    private acl: ACLService,
    private store: StoreService,
    private appSrv: AppService,
  ) {
    console.log("[hostex] App Start Up ...");
  }

  private viaHttp(resolve, reject) {
    const headers = new HttpHeaders({
      "hostex-need-auth": "no",
      "hostex-hide-error": "yes",
    });
    zip(this.http.get("/api/config/init", { headers }), this.http.get("/api/config/hosts", { headers }))
      .pipe(
        catchError((e) => {
          console.warn(`StartupService.load: Network request failed`, e);
          return [];
        }),
        finalize(() => {
          resolve(null);
        }),
      )
      .subscribe(
        ([cRst, hRst]) => {
          console.log("Startup.load Complete: ", [cRst, hRst]);

          const config = cRst?.data;
          // const member = mRst?.data;
          const hosts = hRst?.data;

          if (hosts) {
            this.appSrv.setApp({ international: hosts?.is_global });
          }

          if (!config) {
            resolve(null);
            return;
          }

          let roles = [];
          let abilities = [];

          const {
            group_company_role,
            is_subaccount,
            permission_blacklist = [],
            operator_name,
            user_account,
            has_thirdparty_account,
            hostgpt_tips,
            bt_pk,
            sp_pk,
          } = config;
          const opid = this.store.get("operator_id", 1);

          try {
            window["heap"]?.identify(user_account);
            window["heap"]?.addUserProperties({
              operator_name,
              has_thirdparty_account,
              opid,
              site: hosts?.is_global ? "global" : "china",
            });
          } catch (e) {}

          switch (group_company_role) {
            case "master":
              roles = ["company_master"];
              // this.acl.setRole(['company_master']);
              break;
            case "member":
              roles = ["company_slave", "master"];
              // this.acl.setRole(['company_slave', 'master']);
              break;
            case "none":
              roles = is_subaccount ? ["slave"] : ["master"];
              // is_subaccount ? this.acl.setRole(['slave']) : this.acl.setRole(['master']);
              break;
            default:
              roles = ["master"];
          }

          abilities = permission_blacklist.map((b) => `${b.title}.${b.permission}`);
          // 后端给的是能力黑名单，所以判断时要取反
          this.acl.set({ role: roles, ability: abilities });
          console.log("[Startup SRV] ACL: ", this.acl.data);

          // this.appSrv.setMember({ status: member.status, edition: member.current.edition });
          // this.appSrv.setApp({ international: is_global });
          this.appSrv.setUser({
            account: user_account,
            name: operator_name,
            has_thirdparty_account,
            has_hostgpt_permission: hostgpt_tips,
            opid,
          });

          this.appSrv.setApp({ ...this.appSrv.app, token: { bt_pk, sp_pk } });
          console.log("[Startup SRV] Member: ", this.appSrv.member);
          console.log("[Startup SRV] User: ", this.appSrv.user);
          console.log("[Startup SRV] App: ", this.appSrv.app);

          resolve(null);
        },
        (error) => {
          console.warn("Startup.load error: ", error);
          resolve(null);
        },
      );
  }

  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      /** 所有的初始化操作在这里完成 */
      this.viaHttp(resolve, reject);
      // resolve({})
    });
  }
}
